import { Box, Paper, Stack, Typography, Button, Skeleton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import DevicesLogedinList from '../devices/list';
import AddIcon from '../../shared/icon/add-icon';
import PasswordUpdate from '../account/password_update';
import SetPassword from '../account/set_password';
import { getCalendarTime } from '../../shared/util/dateformatter';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux/features/rootSlice';
import { useArcAuth } from '@arcauth/react-sdk';
import { useNavigate } from 'react-router-dom';
interface loadingSkel {
  loading?: boolean;
}

const AppSecurity = (props:loadingSkel) => {
  const { loading = false } = props;
  const { isAuthenticated, login } = useArcAuth();
  const navigate = useNavigate();
  let user = useSelector(
    (state: RootStateType) => state.userStateReducer.user
  );
  const lastPasswordUpdateDate = getCalendarTime(user?.passwordlastupdated)
  const [openPass, setUpdatePassword] = useState(false);
  const [openPassword, setAddPassword] = useState(false);
  const DialogClose = () => {
    setUpdatePassword(false);
    setAddPassword(false);
  };
  const setChangePassword = () => {
    setUpdatePassword(true);
  }
  const setPassword = () => {
    setAddPassword(true);
  }

  useEffect(() => {
    if (!isAuthenticated) {
      login();
    }
  }, [isAuthenticated, navigate]);
  return (
    <>
      <Box>
        <Stack textAlign={"center"} gap={1} alignItems={"center"} mb={3}>
          <Typography
            variant="h1"
            color="initial"
            fontSize={{ xs: "1.5rem", md: "2.5rem" }}
          >
            Security
          </Typography>
          <Typography variant="body2" color="initial">
            Manage your account preferences and details in one convenient
            location
          </Typography>
        </Stack>
        <Stack gap={2} sx={{ maxWidth: 900, mx: "auto" }}>
          {loading ? (
            <Skeleton
              sx={{ background: "#fff" }}
              variant="rectangular"
              width="100%"
              height={230}
            />
          ) : (
            <Paper elevation={0} sx={{ p: 3, flex: 1 }}>
              <Typography variant="h2" sx={{ fontSize: "0.95rem", fontWeight: 600, color: "initial" }}>
                Password
              </Typography>
              <Typography variant="body2" color="initial" mb={3}>
                Customize password settings for enhanced security
              </Typography>
              {user?.passwordchangerequired ? (
                <>
                  <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    sx={{ borderBottom: "1px solid #eee", py: 1 }}
                  >
                    <Stack>
                      <Typography variant="body2" color="text.secondary">
                        ••••••••
                      </Typography>
                    </Stack>
                  </Stack>
                  <Box py={1}>
                    <Button
                      variant="text"
                      color="primary"
                      onClick={setPassword}
                      sx={{
                        color: "#ED0B14",
                        ":hover": { background: "transparent" },
                        p: 0,
                        minWidth: 0,
                      }}
                    >
                      Set password
                    </Button>
                  </Box>
                </>
              ) : (
                <>
                  <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    sx={{ borderBottom: "1px solid #eee", py: 1 }}
                  >
                    <Stack>
                      <Typography variant="body2" color="text.secondary">
                        ••••••••
                      </Typography>
                      <Typography variant="body2" color="initial">
                        <small>Last changed {lastPasswordUpdateDate}</small>
                      </Typography>
                    </Stack>
                  </Stack>
                  <Box py={1}>
                    <Button
                      variant="text"
                      onClick={setChangePassword}
                      sx={{
                        color: "primary.dark",
                        fontSize: "0.875rem",
                        p: 0,
                        minWidth: 0,
                        ":hover": { background: "transparent" },
                      }}
                    >
                      Change password
                    </Button>
                  </Box>
                </>
              )}
            </Paper>
          )}
          {loading ? (
            <Skeleton
              sx={{ background: "#fff" }}
              variant="rectangular"
              width="100%"
              height={230}
            />
          ) : (
            <Paper elevation={0}>
              <DevicesLogedinList />
            </Paper>
          )}
        </Stack>
      </Box>
      <PasswordUpdate open={openPass} onClose={DialogClose} />
      <SetPassword open={openPassword} onClose={DialogClose} />
    </>
  );
};

export default AppSecurity;
